import React, { Component } from 'react';
import axios from "axios";
//import logoreg from "../abc.png";
import Path from "./config";
export class PaymentSUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            payment_id: ""
        }
    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            phoneId: localStorage.getItem("phoneId")
        })

        let webid = new URLSearchParams(this.props.location.search);
        let webi = webid.get("payment_id");

        //  console.log(webi)
        if (!localStorage.getItem("userId") && webi === "") {
            //alert("please register your number and make payment")
            this.props.history.push(`/`);
        }

        // console.log("paymentid",webidnew+ "userid",localStorage.getItem("userId"),)

    }
    NextForm = () => {
        let webid = new URLSearchParams(this.props.location.search);
        let webidnew = webid.get("payment_id");

        // console.log(webidnew)
        if (this.state.userId !== "" && webidnew !== "") {
            //alert("yes")
            let typee = "Payment";
            let amt = "600";
            let tempStr = "sbg_payment_amount=" + amt +
                "&sbg_id=" + localStorage.getItem("userId") +
                "&type=" + typee

            // console.log("wwwwwwwwwwwwwwwwwwwwwwww",tempStr)
            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    // console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                    if (response.data.status === "updated") {
                        // localStorage.setItem("userId",response.data.sbg_id)
                        this.props.history.push(`/FormProfile/Fullbiodata`);
                        // alert("Payment Received, please fill up the form");
                    } else {
                        alert("Payment not Received");
                    }



                }.bind(this))

            //this.props.history.push('./FormProfile');
        }
        else {
            alert("not")
            //this.props.history.push('/');
        }
    }

    render() {
        //console.log ("userId",this.state.userId );
        //console.log ("paymenId",this.state.payment_id );

        return (
            <>
                <div className="container-fluid text-success text-center m-2 font-weight-normal">
                    Payment Success..
                    <h4 className="text-primary">Thank You </h4>
                </div>
                <div className="container-fluid">

                    <div className="row justify-content-md-center my-2 ">

                        <div className="col-md-12 text-center">

                            <button class="btn btn-primary" type="button" onClick={() => this.NextForm()}>Next</button>

                        </div>
                    </div>

                </div>
            </>
        )
    }
}

export default PaymentSUpdate
